<div id="settings-case-settings-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH SETTINGS LIST -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <action-list [items]="caseSettings"
                                 [selected]="selected"
                                 [idPrefix]="idPrefix"
                                 [identifier]="'key'"
                                 (select)="select($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED CASE SETTINGS  -->

        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content>

                    <work-instructions *ngIf="selected && selected.key === CaseSetting.WORK_INSTRUCTIONS" [idPrefix]="idPrefix"></work-instructions>

                </mat-card-content>
            </mat-card>

        </div>

    </div>

</div>
